/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'filter': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M29 6H15.8c-.4-1.4-1.8-2.5-3.3-2.5-1.6 0-2.9 1.1-3.3 2.5H3v2h6.2c.4 1.4 1.8 2.5 3.3 2.5s2.9-1.1 3.3-2.5H29V6zM12.5 8.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5S14 6.2 14 7s-.7 1.5-1.5 1.5zM29 15h-4.2c-.4-1.4-1.8-2.5-3.3-2.5-1.6 0-2.9 1.1-3.3 2.5H3v2h15.2c.4 1.4 1.8 2.5 3.3 2.5s2.9-1.1 3.3-2.5H29v-2zm-7.5 2.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zM29 24H13.8c-.4-1.4-1.8-2.5-3.3-2.5-1.6 0-2.9 1.1-3.3 2.5H3v2h4.2c.4 1.4 1.8 2.5 3.3 2.5s2.9-1.1 3.3-2.5H29v-2zm-18.5 2.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"/>'
  }
})
